import React, { useContext, useState, useRef } from 'react';
import { CitaContext } from '../../context/CitaContext';

const PaymentOption = ({ icon, title, description, active, onClick }) => (
  <div
    onClick={onClick}
    className={`payment-option-card ${active ? 'is-active' : ''}`.trim()}
    style={{ display: 'flex', alignItems: 'center' }}
  >
    <div
      style={{
        width: '40px',
        height: '40px',
        borderRadius: '50%',
        backgroundColor: '#f0f3fb',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginRight: '15px',
        color: '#6a5acd',
        fontSize: '16px'
      }}
    >
      <i className={icon}></i>
    </div>
    <div>
      <div style={{ fontWeight: 500 }}>{title}</div>
      <div style={{ fontSize: '13px', color: '#666', marginTop: '3px' }}>
        {description}
      </div>
    </div>
  </div>
);

const MetodoPago = () => {
  const { metodoPago, setMetodoPago, setComprobantePago } = useContext(CitaContext);
  const [pagoEfectivo, setPagoEfectivo] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(null);
  const fileInputRef = useRef(null);

  const handleSeleccionarMetodo = (metodo) => {
    setMetodoPago(metodo);

    if (metodo !== 'efectivo') {
      setPagoEfectivo(null);
      setComprobantePago(null);
      setPreviewUrl(null);
    }
  };

  const handleSeleccionarPagoEfectivo = (tipo) => {
    setPagoEfectivo(tipo);
    setMetodoPago(tipo === 'transferencia' ? 'transferencia' : 'efectivo');

    if (tipo !== 'transferencia') {
      setComprobantePago(null);
      setPreviewUrl(null);
    }
  };

  const handleFileChange = (event) => {
    const file = event.target.files?.[0];
    if (!file) return;

    setComprobantePago(file);
    setPreviewUrl(URL.createObjectURL(file));
  };

  const handleSelectFile = () => {
    fileInputRef.current?.click();
  };

  return (
    <div style={{ width: '100%' }}>
      <p className="booking-info">
        <i className="fas fa-info-circle"></i>
        Seleccione un metodo de pago para continuar con su reserva.
      </p>

      <div style={{ display: 'flex', flexDirection: 'column', gap: '15px', marginBottom: '25px' }}>
        <div
          onClick={() => handleSeleccionarMetodo('efectivo')}
          className={`payment-method-card ${metodoPago === 'efectivo' || metodoPago === 'transferencia' ? 'is-active' : ''}`.trim()}
          style={{ width: '100%', display: 'flex', alignItems: 'center' }}
        >
          <div
            style={{
              width: '50px',
              height: '50px',
              borderRadius: '50%',
              backgroundColor: '#f0f3fb',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              marginRight: '15px',
              color: '#6a5acd',
              fontSize: '20px'
            }}
          >
            <i className="fas fa-money-bill-wave"></i>
          </div>
          <div>
            <h4 style={{ margin: '0 0 5px 0', color: '#444' }}>Efectivo</h4>
            <p style={{ margin: 0, color: '#666', fontSize: '14px' }}>
              Pago en local o transferencia bancaria
            </p>
          </div>
        </div>
      </div>

      {(metodoPago === 'efectivo' || metodoPago === 'transferencia') && (
        <div className="booking-summary-card" style={{ marginBottom: '20px' }}>
          <h4 style={{ marginTop: 0, marginBottom: '15px', color: '#444', display: 'flex', alignItems: 'center', gap: '8px' }}>
            <i className="fas fa-credit-card" style={{ color: '#6a5acd' }}></i>
            Como realizaras el pago
          </h4>

          <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
            <PaymentOption
              icon="fas fa-store"
              title="Pago en local"
              description="Pague en efectivo al llegar a su cita"
              active={pagoEfectivo === 'local'}
              onClick={() => handleSeleccionarPagoEfectivo('local')}
            />

            <PaymentOption
              icon="fas fa-university"
              title="Transferencia bancaria"
              description="Realice una transferencia y cargue el comprobante"
              active={pagoEfectivo === 'transferencia'}
              onClick={() => handleSeleccionarPagoEfectivo('transferencia')}
            />
          </div>

          {pagoEfectivo === 'transferencia' && (
            <div className="payment-transfer-box">
              <h4 style={{ margin: '0 0 15px 0', color: '#444', display: 'flex', alignItems: 'center', gap: '8px' }}>
                <i className="fas fa-info-circle" style={{ color: '#6a5acd' }}></i>
                Datos para transferencia
              </h4>

              <div className="payment-bank-grid">
                <div className="payment-bank-key">Banco:</div>
                <div>Banco Nacional</div>
                <div className="payment-bank-key">Titular:</div>
                <div>Clinica Oftalmologica S.A.</div>
                <div className="payment-bank-key">Cuenta:</div>
                <div>123-456789-01</div>
                <div className="payment-bank-key">Referencia:</div>
                <div>Tu nombre completo</div>
              </div>

              <div className="payment-upload-box">
                <h4 style={{ margin: '0 0 10px 0', color: '#444', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}>
                  <i className="fas fa-receipt" style={{ color: '#6a5acd' }}></i>
                  Comprobante de pago
                </h4>

                <p style={{ fontSize: '14px', marginBottom: '20px', color: '#666' }}>
                  Adjunte una imagen de su comprobante de transferencia.
                </p>

                <input
                  type="file"
                  accept="image/*"
                  onChange={handleFileChange}
                  style={{ display: 'none' }}
                  ref={fileInputRef}
                />

                <button
                  onClick={handleSelectFile}
                  type="button"
                  className="booking-btn booking-btn-primary booking-btn-block"
                  style={{ maxWidth: '280px', margin: '0 auto 15px auto' }}
                >
                  <i className="fas fa-upload"></i>
                  Seleccionar imagen
                </button>

                {previewUrl && (
                  <div style={{ marginTop: '20px' }}>
                    <div className="payment-upload-success" style={{ marginBottom: '15px' }}>
                      <i className="fas fa-check-circle"></i>
                      Comprobante cargado correctamente
                    </div>

                    <div
                      style={{
                        border: '1px solid #eaeaea',
                        borderRadius: '8px',
                        padding: '10px',
                        overflow: 'hidden',
                        backgroundColor: 'white',
                        boxShadow: '0 2px 4px rgba(0,0,0,0.05)'
                      }}
                    >
                      <img
                        src={previewUrl}
                        alt="Comprobante de pago"
                        style={{ maxWidth: '100%', maxHeight: '200px', borderRadius: '6px', display: 'block', margin: '0 auto' }}
                      />
                    </div>
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default MetodoPago;